import getRewardsPointsStore from "../store/rewardsPointsStore";

export default function isRewardsButtonVisibleInHeader(accountKey: string): boolean {
    const store = getRewardsPointsStore();
    return store.buttonVisibilityAccountKey === accountKey && store.isButtonVisibleInHeader;
}
